export default {
	methods: {
		pushOrSplice(item, array) {
			const idx = array.indexOf(item);

			if (0 <= idx) array.splice(idx, 1);
			else array.push(item);
		},
		inArray(item, array) {
			const idx = array.indexOf(item);

			return 0 <= idx;
		},
	},
};
